import { Box, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { DataGrid } from '@mui/x-data-grid'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 600 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 2,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))

function AvancementProjetCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  const navigate = useNavigate()

  const [totalPercentage, setTotalPercentage] = useState(0)

  useEffect(() => {
    let sumOfP = 0
    oldData.forEach((el) => {
      let total = el.tasks?.length
      let done = 0
      el.tasks?.forEach((v) => {
        if (v.Done) done++
      })
      sumOfP += done === 0 ? 0 : (done / total) * 100
      setTotalPercentage(sumOfP === 0 ? 0 : sumOfP / oldData.length)
    })
  }, [])

  const columns = [
    {
      field: 'Name',
      headerName: '',
      width: 150,
      editable: false,
      renderCell: (params) => {
        return (
          <Box>
            <Box>{params.row.Name}</Box>
            <Box sx={{ color: '#ffffffa1' }}>
              {convertToUserDateFormate(siteUser.user, params.row.DateCreation)} - {t('syntheseTemps.notAvailable')}
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'Statut',
      headerName: '',
      width: 90,
      editable: false,
      renderCell: (params) => {
        let done = 0
        let tasks = params.row.tasks
        tasks.map((v) => {
          if (v.Done) done++
          return ''
        })
        let text = ''
        let color = ''
        if (tasks.length === done) {
          text = t('syntheseTemps.statusDone')
          color = 'green'
        } else if (done === 0) {
          text = t('syntheseTemps.statusOngoing')
          color = '#a37a00'
        } else if (done > 0 && done < tasks.length) {
          text = t('syntheseTemps.statusNotStarted')
          color = '#a37a00'
        }
        return (
          <Box sx={{ color: color, width: '-webkit-fill-available', textAlign: 'center' }}>
            {text}
          </Box>
        )
      },
    },
    {
      field: '',
      headerName: '',
      width: 100,
      editable: false,
      renderCell: (params) => {
        let total = params.row.tasks?.length
        let done = 0
        params.row.tasks?.map((v) => {
          if (v.Done) done++
          return ''
        })
        let checkListsPercentage = done === 0 ? 0 : (done / total) * 100
        return (
          <Box sx={{ flexGrow: 1 }}>
            <Box position={'absolute'} zIndex={2} marginLeft={1} fontSize={'smaller'}>
              {parseFloat(checkListsPercentage).toFixed(2)} %{' '}
            </Box>
            <BorderLinearProgress variant="determinate" value={checkListsPercentage} />
          </Box>
        )
      },
    },
  ]
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box
          className="dashboard_card__header1 no-drag"
          onClick={() => navigate('/todos/projects')}
        >
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.projectProgressTitle')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {parseFloat(totalPercentage).toFixed(2)}
            {' %'}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.projectProgressSubtitle')}
          </WTypography>
        </Box>

        <Box minWidth={3} mb={6} height={'100%'} borderTop={'1px solid white'}>
          {oldData.length > 0 && (
            <div
              style={{
                height: '100%',
                width: '100% ',
                background: 'unset',
                borderRadius: '5px',
                '.MuiDataGridMain': {
                  color: 'white',
                },
              }}
            >
              <DataGrid
                style={{
                  color: 'white',
                  border: 'unset',
                }}
                sx={{
                  '.MuiDataGrid-cellCheckbox': {
                    color: 'white',
                  },
                  '.MuiDataGrid-cell': {
                    borderBottom: 'unset',
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    whiteSpace: 'unset !important',
                    padding: '4px 2px',
                  },
                  '.MuiCheckbox-root': {
                    color: 'white',
                  },
                  '.Mui-checked': {
                    color: 'white !important',
                  },
                  '.MuiDataGrid-row': {
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    borderBottom: '1px solid #656565',
                  },
                  '& .MuiDataGrid-columnHeaders': { display: 'none' },
                  '& .MuiDataGrid-virtualScroller': { overflow: 'unset', marginTop: '0!important' },
                }}
                rows={oldData}
                columns={columns}
                rowsPerPageOptions={[10, 20, 40, 80, 100]}
                pagination
                paginationMode="server"
                disableSelectionOnClick
                hideFooter
                hideFooterPagination
                disableColumnMenu
                columnHeaderHeight={0}
                onRowClick={(params, event) => {
                  // if (event.target.localName === 'div') {
                  // setProjectTaskId(params.id)
                  // setProjectTaskName(params.row.Name)
                  navigate(`/todos/projects?p=${params.row.id}`)
                  // }
                }}
              />
            </div>
          )}
        </Box>
      </Card>
    </>
  )
}

export default AvancementProjetCard
